import { DOOR_GLASS_10, DOOR_GLASS_1076 } from './doorGlassTypes';

const doorGlassTypesAluGlazyLeafGlassAround = [DOOR_GLASS_10, DOOR_GLASS_1076];

export default doorGlassTypesAluGlazyLeafGlassAround;
